import { Avatar, Box, Button, Chip, Grid, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import ConfirmationBox from 'src/Component/ConfirmationBox'
import SimpleModal from 'src/Component/SimpleModal'
import { useGetParkByIdQuery } from 'src/api/manageParksApi'
import { useGetProductByIdQuery } from 'src/api/manageProductsApi'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'

type ViewModalProps = {
  id: number
  open: boolean
  onClose: () => void
}
const ViewModal = ({ id, open, onClose }: ViewModalProps) => {
  const dispatch = useDispatch<AppDispatch>()
  const { data, isFetching, refetch } = useGetProductByIdQuery(id)

  useEffect(() => {
    if (isFetching) {
      dispatch(startPageLoader())
    } else {
      dispatch(stopPageLoader())
    }
  }, [isFetching])

  return (
    <Box>
      <SimpleModal open={!!(open && id)} onClose={onClose}>
        {!!data && (
          <Box>
            {!!data?.picture && (
              <Box textAlign='center'>
                <img
                  src={data?.picture}
                  style={{
                    height: '250px',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            )}

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Product ID:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data?.id} </Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Product Name:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'>{data.title}</Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Product Type:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'>{data.item_type}</Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Amount per unit :</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.price} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Unit :</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.unit} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Category:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.supplement_type.name} </Typography>
              </Grid>
            </Grid>
          
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Description  :</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {data.description} </Typography>
              </Grid>
            </Grid>
          </Box>
        )}
      </SimpleModal>
    </Box>
  )
}

export default ViewModal
